import React from 'react';
import { styled } from '@mui/material';
import ReplayIcon from '@mui/icons-material/Replay';
import { Button } from 'components/Button/Button';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { useThemeUtils } from 'contexts/ThemeContext/hooks/useThemeUtils';

interface RetryButtonProps {
  onClick: () => void;
}

const StyledButton = styled(Button)(({ theme }) => ({
  gap: theme.spacing(0.5),
  paddingTop: theme.spacing(0.5),
  paddingBottom: theme.spacing(0.5),
  paddingLeft: theme.spacing(4),
  paddingRight: theme.spacing(4),
  fontWeight: 400,
  marginTop: theme.spacing(1),
  '&:hover': {
    backgroundColor: theme.palette.grey[400],
  },
}));

export const RetryButton = ({ onClick }: RetryButtonProps) => {
  const { translation } = useTranslationContext();
  const { theme } = useThemeUtils();

  return (
    <StyledButton variant="tertiary" onClick={onClick} aria-label={translation('retry')}>
      {translation('retry')}
      <ReplayIcon
        fontSize="small"
        sx={{ color: theme.palette.brandShade1.main, transform: 'scaleX(-1)' }}
        aria-hidden="true"
      />
    </StyledButton>
  );
};
